import styled from 'styled-components/macro';
import {ListItemText as MuiListItemText} from '@mui/material';

export const Wrapper = styled.div`
  padding: ${props => props.theme.spacing(0.25)}
    ${props => props.theme.spacing(4)};
  background: ${props => props.theme.footer.background};
  position: relative;
`;

export const ListItemText = styled(MuiListItemText)`
  span {
    color: ${props => props.theme.footer.color};
  }
`;
